import React, {useState, useEffect, useContext} from 'react'
import {WhitelabelContext} from '../OnboardingWhitelabel'
import {Grid} from '@mui/material'
import SelectInput from '../../SelectInput'
import useFormChanged, {NonEmptyStringValidator, DateStringValidator} from '../../hooks/useFormChanged'
import {FormComponentPropTypes} from '../onboardingTypes'
import useSharedStyles from '../useSharedStyles'
import MarkTaskCompletedCTAs from '../FormCTAs/MarkTaskCompletedCTAs'
import {makeStyles} from '@mui/styles'
import {spaceSmall} from '../../../assets/styles/spacing'
import {ONBOARDING_STATE_COMPLETED} from '../../../constants/ModelConstants'
import TextInput from '../../TextInput'
import IconButton from '@mui/material/IconButton'
import RXRIcon from '../../RXRIcon'
import {Colors} from '../../../assets/styles'
import copy from 'copy-to-clipboard'


function RentersInsurance(props) {
  const classes = useStyles()
  const sharedClasses = useSharedStyles()

  /** @type {BuildingWhitelabelConfig} */
  const whitelabel = useContext(WhitelabelContext)

  console.log(whitelabel)

  return (
    <React.Fragment>
      <div className={sharedClasses.bodyContainer}>
        <div className={classes.messageContainer}>Residents are being directed to apply for renter's insurance at the following url:</div>
        <TextInput
          isReadOnly={true}
          value={whitelabel.rentersInsurance.rentersInsuranceURL}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => copy(whitelabel.rentersInsurance.rentersInsuranceURL)} aria-label="Copy to Clipboard" size="large">
                <RXRIcon icon={RXRIcon.COPY} color={Colors.rxrPrimaryColor} />
              </IconButton>
            ),
            readOnly: true,
          }}
        />
      </div>
      <MarkTaskCompletedCTAs onMarkCompleted={() => {
        props.onUpdateSubmission({
          ...props.submission,
          state: ONBOARDING_STATE_COMPLETED,
        })
      }} />
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  messageContainer: {
    marginBottom: spaceSmall,
  },
}))

export default RentersInsurance

RentersInsurance.propTypes = FormComponentPropTypes
